import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import FloLoading from '../FloLoading/FloLoading';

function AuthWrapper({ element: Element }) {
  const { isAuthenticated, isLoading } = useAuth0();
  const location = useLocation();
  const { dataId, path } = useParams();

  const redirectToLoginWithReturnUrl = () => {
    setInterval(() => {}, 6000)

    const returnUrl = dataId
      ? `${window.location.origin}${location.pathname}`
      : path || location.pathname;

    sessionStorage.setItem('returnUrl', returnUrl);
    return <Navigate to="/login" replace />;
  };

  if (isLoading) {
    return <FloLoading />;
  }

  // Redirect unauthenticated users to login
  if (!isAuthenticated) {
    return redirectToLoginWithReturnUrl();
  }

  // ✅ Added this: define hasAcceptedTerms
  const hasAcceptedTerms = localStorage.getItem('termsAccepted') === 'true';

  // Redirect to terms page if user hasn't accepted and isn't already there
  if (!hasAcceptedTerms && location.pathname !== '/terms') {
    sessionStorage.setItem('returnUrl', location.pathname);
    return <Navigate to="/terms" replace />;
  }

  // All checks passed — render the protected route
  return <Element />;
}

export default AuthWrapper;
